import { IVideoSchema } from '../../../repositories/developer-card/entities/developer_special_promo/VideoSchema';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoVideo(state: IApplicationState): IVideoSchema | undefined {
  return getTemplateSpecialPromo(state)?.video;
}
